import {
    GeoRunnerName,
    IGeoRetryOnOpenRealGame,
    ILoginGeoLocationOptions,
    IOpenGameGeoLocationOptions,
    IPeriodicGeoUpdateOptions
} from "./geo-location-runner.interface";
import {IGeoRestrictionsUpdateEventParams} from "../../sdk/sdk-events";
import {GeoValidationResult, IGeoRunResult} from "../strategies/geo-location.strategy.interface";
import {GeoGameRestrictedDialogButton, GeoKickDialogButtons} from "./geo-location-dialogs-factory";
import {GeoLocationRunnerBase} from "./geo-location-runner-base";
import {GeoAnalyticsEvent} from "../geo-location-analytics";
import {KICK_REASON} from "../../../../sdk/src/services/player_messages_service/player_messages_consts";

export class GeoLocationRunnerInOtherBrands extends GeoLocationRunnerBase {

    protected _getRunnerName(): GeoRunnerName {
        return "OtherBrands";
    }

    geoKick(params: IGeoRestrictionsUpdateEventParams): Promise<IGeoRunResult> {
        this._analytics.reportEvent({
            geoEventName: GeoAnalyticsEvent.GeoKick,
            kickParams: params
        });
        return this._executeGeoFlow('geoKick', () => this._executeGeoKick(params));
    }

    private _executeGeoKick(params: IGeoRestrictionsUpdateEventParams): Promise<IGeoRunResult> {
        return new Promise<IGeoRunResult>(resolve => {

            if(this.services.miniOrbit.isEnabled) {
                //TODO - what about CIP8 on iOS
                //On mini orbit they will show the geo kick message
                resolve({
                    validationResult: GeoValidationResult.Fail,
                    kickParams: params
                });
            } else {
                this._geoDialogs.showGeoKickDialog({
                    buttons: GeoKickDialogButtons.OK,
                    kickReasonId: params.KickReasonId,
                    troubleShooterMessages: params.DetailedMessages,
                    isGenericKickMessage: false
                }).then(() => {
                    resolve({
                        validationResult: GeoValidationResult.Fail,
                        kickParams: params
                    });
                });
            }
        });
    }

    //On login, we always get isGeoLocationInProcess = false when we are hosted in other brands apps. So this method is never called.
    //However, if for some reason platform will return isGeoLocationInProcess = true in autologin then we return from this method Pass
    //and relay on the restrictions that will block the user for playing.
    //This is because when we are hosted in other brands apps we can't really perform geolocation.
    loginGeoLocation(options: ILoginGeoLocationOptions): Promise<IGeoRunResult> {
        return this._executeGeoFlow('loginGeoLocation', () => {
            this._analytics.setTransactionId(options.geoStrategyRunParams.locationTransactionId);
            this._analytics.reportEvent({
                geoEventName: GeoAnalyticsEvent.StartLoginGeo
            });
            return this._passGeo();
        });
    }

    //This method behave similar to loginGeoLocation. Basically this method should never be called in other brands because usually platform returns isGeoLocationInProcess = false on login.
    openGameGeoLocation(options: IOpenGameGeoLocationOptions): Promise<IGeoRunResult> {
        return this._executeGeoFlow('openGameGeoLocation', () => {
            this._analytics.setTransactionId(options.geoStrategyRunParams.locationTransactionId);
            this._analytics.reportEvent({
                geoEventName: GeoAnalyticsEvent.StartOpenGameGeo
            });
            return this._passGeo();
        });
    }


    //We can't run geo on other brands, so we just return Pass and relay on the hosting app to do the periodic geo
    runPeriodicGeo(options: IPeriodicGeoUpdateOptions): Promise<IGeoRunResult> {
        return this._executeGeoFlow('runPeriodicGeo', () => {
            this._analytics.setTransactionId(options.geoStrategyRunParams.locationTransactionId);
            this._analytics.reportEvent({
                geoEventName: GeoAnalyticsEvent.PeriodicGeo
            });
            return this._passGeo();
        });
    }

    //Since we cannot run geo in other brands then here we fail because it means that the open real game got a block by country error code or has geo restrictions
    //and the only thing we can do is to show the game geo restricted popup (done in the GeoLocationService)
    geoRetryOnOpenRealGame(options: IGeoRetryOnOpenRealGame): Promise<IGeoRunResult> {
        return this._executeGeoFlow('geoRetryOnOpenRealGame', () => {
            this._analytics.reportEvent({
                geoEventName: GeoAnalyticsEvent.StartRetryOnOpenGame
            });
            return this._failGeo();
        });
    }

    showGameRestrictedPopup(): void {
        this._geoDialogs.showGeoRestrictionPopup({
            buttons: GeoGameRestrictedDialogButton.OK
        });
    }

    async showGenericGeoKickMessage(): Promise<void> {
        await this._geoDialogs.showGeoKickDialog({
            buttons: GeoKickDialogButtons.OK,
            troubleShooterMessages: [],
            kickReasonId: KICK_REASON.KickUserTechProblem,
            isGenericKickMessage: true
        });
    }

    private _passGeo(): Promise<IGeoRunResult> {
        return Promise.resolve({
            validationResult: GeoValidationResult.Pass
        });
    }

    private _failGeo(): Promise<IGeoRunResult> {
        return Promise.resolve({
            validationResult: GeoValidationResult.Fail
        });
    }

}